import { data } from '../../svg/Visibility/data';
import { makeIcon } from '../makeIcon';

export const Visibility = makeIcon(data, 'visibility', 'Visibility');

export default Visibility;
